import "../../design/resetPassword.css";
import { useState } from "react";
import api, { API_URL } from "../../api/API_SERVERS";
import Toast from "../../utils/components/Toast";
import Loading from "../../utils/components/Loading";

export default function ResetPassword() {

    const [password, setPassword] = useState("");
    const [passwordRules, setPasswordRules] = useState({});
    const [passwordStrength, setPasswordStrength] = useState("");
    const [loading, setLoading] = useState(false);
    const [toast, setToast] = useState(null);

    const showToast = (message, type = "error") => {
        setToast({ message, type });
    };

    const token = new URLSearchParams(window.location.search).get("token");

    const validatePassword = (password) => ({
        length: password.length >= 8,
        lowercase: /[a-z]/.test(password),
        uppercase: /[A-Z]/.test(password),
        number: /[0-9]/.test(password),
        special: /[!@#$%^&*]/.test(password),
    });

    const getStrength = (rules) => {
        const passed = Object.values(rules).filter(Boolean).length;
        if (passed === 0) return "";
        if (passed <= 2) return "weak";
        if (passed <= 4) return "medium";
        return "strong";
    };

    const handlePasswordChange = (value) => {
        setPassword(value);
        const rules = validatePassword(value);
        setPasswordRules(rules);
        setPasswordStrength(getStrength(rules));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!token) {
            showToast("Token არ არსებობს");
            return;
        }

        const rules = validatePassword(password);
        const allValid = Object.values(rules).every(Boolean);

        if (!allValid) {
            showToast("პაროლი არ აკმაყოფილებს მოთხოვნებს!");
            return;
        }

        try {
            setLoading(true);

            const res = await api.post(
                API_URL + "/api/teachers/reset-password",
                {
                    token,
                    newPassword: password,
                }
            );

            showToast(res.data.message, "success");

            setTimeout(() => {
                window.location.href = "/login";
            }, 1200);

        } catch (e) {
            const message = e.response?.data?.message || "დაფიქსირდა შეცდომა";
            showToast(message);
        } finally {
            setLoading(false);
            setPassword("");
        }
    };

    return (
        <div className="forgot-container">
            {loading && <Loading />}
            {toast && (
                <Toast
                    message={toast.message}
                    type={toast.type}
                    onClose={() => setToast(null)}
                />
            )}

            <form className="forgot-form" onSubmit={handleSubmit}>
                <h2 className="forgot-title">ახალი პაროლი</h2>

                <div className="forgot-input-group">
                    <label className="forgot-input-label">პაროლი</label>

                    <input
                        type="password"
                        className="forgot-input-field"
                        value={password}
                        onChange={(e) => handlePasswordChange(e.target.value)}
                        placeholder="შეიყვანეთ ახალი პაროლი"
                        required
                    />

                    {/* RULES */}
                    <div className="reset-password-rules">
                        {Object.entries({
                            "მინიმუმ 8 სიმბოლო": passwordRules.length,
                            "პატარა ასო (a-z)": passwordRules.lowercase,
                            "დიდი ასო (A-Z)": passwordRules.uppercase,
                            "ციფრი (0-9)": passwordRules.number,
                            "სიმბოლო (!@#$)": passwordRules.special,
                        }).map(([label, valid], idx) => (
                            <div
                                key={idx}
                                className={`reset-rule-item ${valid ? "valid" : "invalid"}`}
                            >
                                {valid ? "✔️" : "❌"} {label}
                            </div>
                        ))}
                    </div>

                    {/* STRENGTH */}
                    <div className="reset-strength-bar">
                        <div className={`strength ${passwordStrength}`} />
                    </div>
                    <span className="reset-strength-label">{passwordStrength}</span>
                </div>

                <button
                    type="submit"
                    className="forgot-submit-button"
                    disabled={loading}
                >
                    პაროლის განახლება
                </button>
            </form>
        </div>
    );
}